import { Container, Row } from "reactstrap";
import ClipboardOnParagraph from "./ClipboardOnParagraph";
import ClipboardOnTextArea from "./ClipboardOnTextArea";
import ClipboardOnTextInput from "./ClipboardOnTextInput";
import CopyPortionFromParagraph from "./CopyPortionFromParagraph";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { ClipBoardTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";

const ClipboardContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ClipBoardTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <Row>
          <ClipboardOnTextInput />
          <ClipboardOnTextArea />
          <ClipboardOnParagraph />
          <CopyPortionFromParagraph />
        </Row>
      </Container>
    </>
  );
};
export default ClipboardContainer;
